// Google Analytics 4 (GA4) helpers.
//
// The Google tag (gtag.js) is loaded from index.html and only on the live
// production domain, so on dev/preview builds `window.gtag` is undefined and
// every function below becomes a safe no-op.

export const GA_MEASUREMENT_ID = "G-814NSNX36X";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function gtagReady(): boolean {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/** Record a GA4 page_view. Used for single-page-app route changes. */
export function trackPageView(pagePath: string): void {
  if (!gtagReady()) return;
  window.gtag!("event", "page_view", {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Record a custom GA4 event. */
export function trackEvent(
  name: string,
  params: Record<string, unknown> = {},
): void {
  if (!gtagReady()) return;
  window.gtag!("event", name, params);
}
